<template>
  <div id="app" style="min-width: 1280px">
    <nv-bar v-if="!isGame"></nv-bar>
    <router-view></router-view>
    <nv-footerbar v-if="!isGame"></nv-footerbar>
    <nv-footer v-if="!isGame"></nv-footer>
  </div>
</template>

<script>
  import nvHeader from './components/header/header'
  import nvBar from './components/header/navbar'
  import nvFooterbar from './components/footer/footer_nav'
  import nvFooter from './components/footer/footer'
  const Home={
    data(){
      return{
        isGame:false
      }
    },
    components:{
      nvHeader,
      nvBar,
      nvFooter,
      nvFooterbar
    },
    mounted:function(){
      this.isGame = (this.$router.currentRoute.path == "/toGame")

    },
    updated(){
      this.isGame = (this.$router.currentRoute.path == "/toGame")
    }
  }
  export default Home
</script>

<style>
</style>

